import { render, staticRenderFns } from "./GlobalMainBanner.vue?vue&type=template&id=490f74da"
import script from "./GlobalMainBanner.vue?vue&type=script&lang=js"
export * from "./GlobalMainBanner.vue?vue&type=script&lang=js"
import style0 from "./GlobalMainBanner.vue?vue&type=style&index=0&id=490f74da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports